import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
      <p>This is a placeholder for the Terms & Conditions page.</p>
    </div>
  );
};

export default TermsAndConditions;